import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formatNamesInObject } from './utils/format-person-name';

@Injectable()
export class FormatPersonNamesInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body != null) {
          const body = event.body;
          if (typeof body === 'object' && !(body instanceof Blob) && !(body instanceof ArrayBuffer)) {
            return event.clone({ body: formatNamesInObject(body) });
          }
        }
        return event;
      })
    );
  }
}
